import Stage from "@fae/source/models/Stage.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"

import skills from "@fae/source/data/skills.jsx"

export default class Reactions {
    static getSteps(stage) {
        let steps = []

        const deaths = Reactions.getDeaths(stage)
        deaths.forEach((death) => {
            const unit = stage.units[death.unitKey]

            unit.skillKeys.forEach((skillKey) => {
                const skill = skills[skillKey]
                if(skill == undefined) return
                if(skill.type != "death") return
                if(skill.calculateStep instanceof Function) {
                    const step = skill.calculateStep({
                        "performerKey": unit.key,
                        "stage": stage,
                    })
                    stage = step.omegastage
                    steps.push(step)
                }
            })
            // TODO: what happens if multiple folks die at once, and i try to
            // run their skills all off the same stage (not a rolling omegastage)
            // I need to have something similiar to Step.add(step, deltastage)
            // but for Action.add(action, step)
        })

        deaths.forEach((death) => {
            // steps = steps.concat(Stage.getEventSteps(stage, "death:" + stage.units[death.unitKey].key))
            // stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            //
            // steps = steps.concat(Stage.getEventSteps(stage, "death:" + stage.units[death.unitKey].type))
            // stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

            const unit = stage.units[death.unitKey]

            if((unit.hasSlowDeath == true || unit.properties?.includes("slow-death"))
            && unit.deathTimer == undefined) {
                if(unit.scripts != undefined
                && unit.scripts["death"] != undefined) {
                    let events = unit.scripts["death"]
                    if(events instanceof Array == false) {
                        events = new Array(events)
                    }
                    steps = steps.concat(Stage.processEventSteps(stage, events))
                    stage = steps.length > 0 ? steps[steps.length - 1].omegastage : stage
                }

                steps.push(Step.instantiate({
                    "name": "death",
                    "type": "invoke skill",
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "unit": {
                                "key": death.unitKey,
                                "deathTimer": 2,
                                "spriteKey": "embering",
                                "portraitKey": "dying",
                                // "power": 100,
                            }
                        }
                    ]
                }))
                return
            }

            if(death.type == "death-by-killzone") {
                steps.push(Step.instantiate({
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "unit": {
                                "key": death.unitKey,
                                "health": Math.min(0, unit.health - 30)
                            }
                        }
                    ]
                }))
            }

            let events = undefined

            if(unit.scripts != undefined
            && unit.scripts["death"] != undefined
            && unit.scripts["death"].length > 0) {
                events = unit.scripts["death"]
            }

            stage.scripts.forEach((condition) => {
                if(condition.trigger == "death"
                && condition.unitKey == death.unitKey) {
                    if(condition.condition instanceof Function
                    && condition.condition(stage) != true) {
                        return
                    }
                    events = condition.events
                    events.unshift({
                        "name": "SavestateCapture",
                        "savestateSlug": condition.title || "Condition_" + stage.scripts.indexOf(condition),
                        "omegastage": stage,
                    })
                }
            })

            if(events != undefined) {
                if(events instanceof Array == false) {
                    events = new Array(events)
                }
                steps = steps.concat(Stage.processEventSteps(stage, events))
                stage = steps.length > 0 ? steps[steps.length - 1]?.omegastage : stage
            }

            if(death.type == "death-by-killzone") {
                steps.push(Step.instantiate({
                    "name": "death",
                    "type": "invoke skill",
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "audio": {"triggerKey": "Unit:Death"},
                        },
                        {
                            "mark": 0,
                            "unit": {"key": death.unitKey, "opacity": 1, "position": unit.position, "rotation": 0}
                        },
                        {
                            "mark": 500,
                            "unit": {"key": death.unitKey, "opacity": 1, "position": unit.position, "rotation": 0}
                        },
                        {
                            "mark": 500 + 200,
                            "unit": {"key": death.unitKey, "opacity": 0},
                        },
                        {
                            "mark": 500 + 300,
                            "unit": {"key": death.unitKey, "position": Geometry.add(unit.position, {"y": 3}), "rotation": 50},
                        },
                        {
                            "mark": 500 + 400,
                            "unit": {"key": death.unitKey, "isDead": true}
                        },
                        // {
                        //     "mark": 300,
                        //     "stage": {
                        //         "units": {
                        //             [death.unitKey]: undefined,
                        //         },
                        //     }
                        // },
                        {
                            "mark": 300,
                            ...Step.flag("tutorial:hasKilled", true)
                        }
                    ]
                }))
            } else {
                steps.push(Step.instantiate({
                    "name": "death",
                    "type": "invoke skill",
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "audio": {"triggerKey": "Unit:Death"},
                        },
                        {
                            "mark": 0,
                            "unit": {"key": death.unitKey, "opacity": 1}
                        },
                        {
                            "mark": 300,
                            "unit": {"key": death.unitKey, "opacity": 0}
                        },
                        {
                            "mark": 300,
                            "unit": {"key": death.unitKey, "isDead": true}
                        },
                        // {
                        //     "mark": 300,
                        //     "stage": {
                        //         "units": {
                        //             [death.unitKey]: undefined,
                        //         },
                        //     }
                        // },
                        {
                            "mark": 300,
                            ...Step.flag("tutorial:hasKilled", true)
                        }
                    ]
                }))
            }
            stage = steps.length > 0 ? steps[steps.length - 1].omegastage : stage

            if(unit.maxexperience != undefined
            && unit?.levelingCriteria?.includes("dying") == true) {
                steps.push(Step.instantiate({
                    "name": "get experience from dying",
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "unit": {"key": unit.key, "experience": unit.experience + 20}
                        },
                    ]
                }))
                stage = steps.length > 0 ? steps[steps.length - 1].omegastage : stage
            }
        })

        // One big death event for all the units dying? Or individual deaths?
        // TO THINK ABOUT: How to handle death text?
        // TO THINK ABOUT: How to overlap this and the death text with the killing blows?
        // TODO: change this to the new schema v2

        return steps
    }
    static getDeaths(stage) {
        const deaths = Object.values(stage.units).map((unit) => {
            if(unit.type == "zone" || unit.type == "spot") return // Zones can not be killed.
            if(unit.deathTimer != undefined) return // That which is dying can not be killed.
            if(unit.isDead == true) return // The dead can not be rekilled.
            if(unit.isRemoved == true) return

            const killzone = Object.values(stage.world.spots).find((spot) => {
                return (spot.tag == "kill" || spot.tag == "death")
                    && spot.position.x == unit.position.x
                    && spot.position.y == unit.position.y
            }) || Object.values(stage.units).find((nextunit) => {
                return (nextunit.type == "zone"  || nextunit.type == "spot")
                    && nextunit.intent == "kill"
                    && nextunit.position.x == unit.position.x
                    && nextunit.position.y == unit.position.y
            })
            if(killzone != undefined) {
                return {"unitKey": unit.key, "type": "death-by-killzone"}
            }

            // const nextTerrain = World.getTerrain(stage.world, unit.position)
            // if(nextTerrain == undefined) {
            //     return {"unitKey": unit.key, "type": "death-by-falling"}
            // }

            if(unit.health <= 0) {
                return {"unitKey": unit.key, "type": "death-by-damage"}
            }
            // TODO: Death by leaving zone?
            // TODO: Death by change of height?
            // TODO: Death by being over "z<0"
        })

        return deaths.filter((death) => !!death)
    }
}
